import type { ButtonHTMLAttributes, ReactNode } from 'react';
import '../../styles/buttons.css';

export type ButtonVariant = 'primary' | 'accent' | 'sub' | 'muted' | 'danger' | 'danger-outline' | 'success';
export type ButtonSize = 'md' | 'sm';

export interface ButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'className'> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  children: ReactNode;
  className?: string;
  loading?: boolean;
}

// variant を グローバルクラスにマッピング（sizeに応じて-smサフィックスを追加）
const getButtonClass = (variant: ButtonVariant, size: ButtonSize): string => {
  const baseClassMap: Record<ButtonVariant, string> = {
    primary: 'btn-modal',
    accent: 'btn-modal-accent',
    sub: 'btn-modal-sub', // ブランドのサブカラー (buttons.css の .btn-modal-sub)
    muted: 'btn-cancel',
    danger: 'btn-modal-danger',
    'danger-outline': 'btn-modal-danger-outline',
    success: 'btn-modal', // successもbtn-modalを使用
  };

  const baseClass = baseClassMap[variant];
  return size === 'sm' ? `${baseClass}-sm` : baseClass;
};

export function Button({
  variant = 'primary',
  size = 'md',
  children,
  className = '',
  disabled = false,
  loading = false,
  type = 'button',
  ...rest
}: ButtonProps) {
  const buttonClass = getButtonClass(variant, size);
  const loadingClass = loading ? 'button-loading' : '';

  const combinedClassName = [
    buttonClass,
    loadingClass,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      type={type}
      className={combinedClassName}
      disabled={disabled || loading}
      {...rest}
    >
      {children}
    </button>
  );
}
